import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Legend,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";

import OverviewMetricsChart from "./OverviewMetricsChart";
import {
  buildConcretePoursChartData,
  getConcretePoursChartOptions,
} from "./chartsHelpers";

ChartJS.register(CategoryScale, LinearScale, BarElement, Legend, Tooltip);

/**
 * Concrete Pours overview chart: poured volume (CY) stacked by mix design.
 * Defaults to Weekly for Range All (≥ 8 weeks), else Daily; user can toggle.
 *
 * @param {Object} props
 * @param {Array<Object>} [props.days] - Aggregated day rows from concrete metrics.
 * @param {{key?: string, start: string|null, end: string|null}|null} [props.range] - Active Range filter.
 * @param {string} [props.typeLabel="All"] - Active Type name for legend/tooltips.
 * @param {boolean} [props.isLoading] - Whether source metrics are still loading.
 * @returns {JSX.Element}
 */
const ConcretePoursChart = ({
  days = [],
  range = null,
  typeLabel = "All",
  isLoading = false,
}) => (
  <OverviewMetricsChart
    days={days}
    range={range}
    typeLabel={typeLabel}
    isLoading={isLoading}
    emptyMessage="No pours in this range"
    buildChartData={buildConcretePoursChartData}
    getChartOptions={getConcretePoursChartOptions}
    renderChart={(data, options) => <Bar data={data} options={options} />}
  />
);

export default ConcretePoursChart;
